export default "__VITE_ASSET__DEfKnP5g__"